module.exports = __webpack_public_path__ + "img/discount_des_bg.4a8faf77.png";